var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w100"},[_c('div',{staticClass:"mal30 mab40"},[_c('PanelCompetitionSettingStoperMain',{attrs:{"id":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }